window.VH = window.VH === undefined ? {} : window.VH;

VH.QuizzRational = {
    currentData : {},

    checkCommentsShow : function checkCommentsShow () {
        if (parseInt($('#quizzrational-q_05 :checked').val()) > 3) {
            $('#q5Comment').show();
        } else {
            $('#q5Comment').hide();
        }

        if ($('#quizzrational-q_07 :checked').val() === 'no') {
            $('#q7Comment').show();
        } else {
            $('#q7Comment').hide();
        }
    },

    initValue : function initValue(element, callback) {
        let _t = VH.QuizzRational,
            id=$(element).val();
        if (id !== '') {
            $.ajax('/quizz/quizz-rational/get-order?id=' + id, {
                dataType: 'json'
            }).done(function(data) {
                callback(data.results);
                VH.QuizzRational.currentData[data.results[0].id] = data.results[0];
                _t.updateFields(true);
            });
        }
    },

    updateFields : function updateFields(fillOnlyEmpty) {
        let _t = VH.QuizzRational,
            data = _t.currentData[$('#ddOrder').select2('val')],
            sel;

        if (fillOnlyEmpty === true) {
            sel = $('#quizzrational-q_11_02');
            if (sel.val() === '') {
                sel.val(data.client);
            }
            sel = $('#quizzrational-q_11_03');
            if (sel.val() === '') {
                sel.val(data.clientAddress);
            }
            sel = $('#quizzrational-q_11_09');
            if (sel.val() === '') {
                sel.val(data.clientPhone);
            }
            sel = $('#quizzrational-q_12');
            if (sel.val() === '') {
                sel.val(data.serial);
            }
            sel = $('#quizzrational-q_13');
            if (sel.val() === '') {
                sel.val(data.date);
            }
        } else {
            $('#quizzrational-q_11_02').val(data.client);
            $('#quizzrational-q_11_03').val(data.clientAddress);
            $('#quizzrational-q_11_09').val(data.clientPhone);
            $('#quizzrational-q_12').val(data.serial);
            $('#quizzrational-q_13').val(data.date);
        }
    },

    init : function init() {
        let _t = VH.QuizzRational;

        $('#quizzrational-q_05, #quizzrational-q_07').on('change', 'input', _t.checkCommentsShow);
        _t.checkCommentsShow();

        $('#ddOrder').on('change', _t.updateFields);
    }
};
